import classnames from "classnames";
import useCustomRef from "hooks/useCustomRef";
import Select from "react-select";
import NumberFormat from "react-number-format";
import { InputText } from "primereact/inputtext";

import { Dropdown } from "primereact/dropdown";
import { AutoComplete } from "primereact/autocomplete";

import React, { useMemo } from "react";
import { Controller, useFormContext } from "react-hook-form";

import { inputNumericoEnteros } from "./validaciones";
import SimpleErrorMessage from "components/InputsMex/containers/SimpleErrorMessage";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es";
import "../styles.scss";

export const SimpleCheckBox = ({
  name,
  label,
  rules = {},
  defaultValue = false,
  id,
  type = "normal",
}) => {
  return (
    <div className={"row"}>
      <Controller
        name={name}
        defaultValue={defaultValue}
        rules={rules}
        render={({ value, onChange }) => (
          <div className='col-1' style={{ marginRight: "-1em" }}>
            <input
              type='checkbox'
              id={id}
              className='chek-terminos'
              checked={value}
              onChange={(evt) => {
                onChange(evt.target.checked);
              }}
            />
            {type === "slide" && <label for={name} className='check-type-slide'></label>}
          </div>
        )}
      />
      <div className='col-11'>
        <label for={name} className='disclaimers-auto'>
          {label}
          <br></br>
          <SimpleErrorMessage name={name} />
        </label>
      </div>
    </div>
  );
};

//Check box for Pymes
export const SimpleCheckBoxB = ({
  name,
  label,
  rules = {},
  defaultValue = false,
  id,
  type = "normal",
  fontSize = "1em",
  disabled = false,
  onChangeFn = () => {},
}) => {
  return (
    <div className='d-flex'>
      <Controller
        name={name}
        defaultValue={defaultValue}
        rules={rules}
        render={({ value, onChange }) => (
          <div className='my-auto'>
            <input
              type='checkbox'
              id={id}
              className='chek-terminos my-auto mr-2'
              disabled={disabled}
              checked={value}
              onChange={(evt) => {
                onChange(evt.target.checked);
                onChangeFn(evt.target.checked);
              }}
            />
            {type === "slide" && <label for={name} className='check-type-slide'></label>}
          </div>
        )}
      />
      <div className='d-flex'>
        <label
          for={name}
          // className="disclaimers-auto"
          className='my-auto'
          style={{ fontSize }}>
          {label}
          <br></br>
          <SimpleErrorMessage name={name} />
        </label>
      </div>
    </div>
  );
};

export const TextInput = ({
  rules,
  inputProps,
  extrasClasses,
  allowNegative = false,
  isUpper = false,
  hideArrows = false,
  defaultValue = null,
  sufijo = "",
  disabled = false,
  onChangeFn = () => {},
  numerico = false,
}) => {
  const { register, control } = useFormContext();
  const { focusRef, setRef } = useCustomRef(null);

  const memoProps = useMemo(() => {
    if (inputProps.isNumberInt) {
      const newInputProps = {
        ...inputProps,
        type: "number",
        onKeyDown: inputNumericoEnteros,
      };
      delete newInputProps.isNumberInt;

      return newInputProps;
    }
    return inputProps;
  }, [inputProps]);

  return (
    <Controller
      control={control}
      name={inputProps.name}
      rules={rules}
      defaultValue={defaultValue}
      onFocus={focusRef}
      render={({ onChange, value, ref }) => {
        return (
          <React.Fragment>
            {numerico && (
              <NumberFormat
                defaultValue={defaultValue}
                allowNegative={allowNegative}
                suffix={sufijo}
                thousandSeparator={true}
                decimalScale='2'
                readOnly={disabled}
                onValueChange={(v) => {
                  onChange(v.value !== "" ? v.value * 1 : null);
                  onChangeFn(v.value !== "" ? v.value * 1 : null);
                }}
                value={value !== null && value !== undefined ? value : ""}
                className={`w-100 border-0 input-line-heigth-cero input-home-cotizacion-type1bold ${extrasClasses}`}
              />
            )}
            {!numerico && (
              <input
                id={inputProps.name}
                readOnly={disabled}
                className={classnames({
                  [`input-line-heigth-cero input-home-cotizacion-type1bold ${extrasClasses}`]: true,
                  "hide-arrows": hideArrows,
                })}
                ref={register(rules)}
                {...memoProps}
                defaultValue={defaultValue}
                onChange={(e) => {
                  if (isUpper) {
                    onChange(e.target.value.toUpperCase());
                    onChangeFn(e.target.value.toUpperCase());
                  } else {
                    onChange(e.target.value);
                    onChangeFn(e.target.value);
                  }
                }}
                //ref={(ref) => console.log('REF: ', ref)}
              />
            )}
          </React.Fragment>
        );
      }}
    />
  );
};

export const Autocompletar = ({
  name,
  rules,
  type = "number",
  minLength = 1,
  maxLength = 10,
  completeMethod = () => {},
  suggestions = [],
  onSelectCodPostal = () => {},
  onUnselect = () => {},
  onChangeFn,
  dataKey,
  loading,
  disabled = false,
  defaultValue = null,
  placeholder = "SELECCIONE",
  loadingText = "BUSCANDO...",
  helpText,
  filter = true,
  emptyFilterMessage = "NO SE HA ENCONTRADO INFORMACIÓN",
  showClear = true,
  ...props
}) => {
  const { control } = useFormContext();

  //const inputRef = useRef(null);
  const internalPlaceHolder = useMemo(
    () => (loading ? loadingText : placeholder),
    [loading, placeholder, loadingText]
  );

  const { focusRef, setRef } = useCustomRef(null);

  return (
    <React.Fragment>
      <Controller
        control={control}
        name={name}
        rules={rules}
        defaultValue={defaultValue}
        onFocus={focusRef}
        render={({ onChange, value, ref }) => {
          return (
            <AutoComplete
              showClear={showClear}
              minLength={minLength}
              maxlength={maxLength}
              forceSelection={true}
              onSelect={onSelectCodPostal}
              className='input__mask__mex'
              inputId={name}
              completeMethod={completeMethod}
              suggestions={suggestions}
              dataKey={dataKey}
              placeholder={internalPlaceHolder}
              disabled={loading || disabled}
              value={value ? value : ""}
              helpText={helpText}
              style={{ width: "100%" }}
              ref={setRef("focusInput")}
              emptyFilterMessage={emptyFilterMessage}
              onChange={(evt) => {
                onChange(evt.value);
                onChangeFn && onChangeFn(evt.value);
              }}
              onBlur={onUnselect}
              //panelStyle={{ overFlow: 'hidden' }}
            />
          );
        }}
      />
    </React.Fragment>
  );
};

export const DropDownFilterX = ({
  name,
  rules,
  showClear = true,
  onSelect = () => {},
  optionLabel = "label",
  optionValue = "value",
  options = [],
  onChangeFn = () => {},
  dataKey,
  loading,
  disabled = false,
  defaultValue = null,
  placeholder = "SELECCIONE",
  loadingText = "BUSCANDO...",
  helpText,
  filter = true,
  emptyFilterMessage = "NO SE HA ENCONTRADO INFORMACIÓN",
  ...props
}) => {
  const { control } = useFormContext();

  //const inputRef = useRef(null);
  const internalPlaceHolder = useMemo(
    () => (loading ? loadingText : placeholder),
    [loading, placeholder, loadingText]
  );

  const { focusRef } = useCustomRef(null);

  return (
    <React.Fragment>
      <Controller
        control={control}
        name={name}
        rules={rules}
        defaultValue={defaultValue}
        onFocus={focusRef}
        render={({ onChange, value, ref }) => {
          return (
            <Dropdown
              className='input__mask__mex'
              inputId={name}
              //showFilterClear={showClear}
              showClear={showClear}
              filterInputAutoFocus={false}
              optionLabel={optionLabel}
              optionValue={optionValue}
              options={options}
              filter={options.length > 6}
              dataKey={dataKey}
              placeholder={internalPlaceHolder}
              disabled={loading || disabled}
              value={value ? value : ""}
              helpText={helpText}
              style={{ width: "100%" }}
              //ref={setRef("focusInput")}
              ref={ref}
              emptyFilterMessage={emptyFilterMessage}
              onChange={(evt) => {
                onChange(evt.value ? evt.value : "");
                onChangeFn && onChangeFn(evt.value ? evt.value : "");
                onSelect(evt.value ? evt.value : "");
                //onSelect();
              }}

              //panelStyle={{ overFlow: 'hidden' }}
            />
          );
        }}
      />
    </React.Fragment>
  );
};

const customStylesDropDown = {
  menu: (provided, state) => ({
    ...provided,
    color: state.selectProps.menuColor,
    marginLeft: "-1em",
  }),
  placeholder: (provided, state) => ({
    ...provided,
    fontSize: "14px",
    fontWeigth: "bold",
    color: "#6c757d",
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    fontSize: "14px",
    fontWeigth: "bold",
  }),
  control: (styles) => ({
    ...styles,
    border: "none",
    boxShadow: "none",
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    const color = "#001871";
    return {
      ...styles,
      // backgroundColor: isDisabled
      //   ? null
      //   : isSelected
      //   ? data.color
      //   : isFocused
      //   ? "#e9ecef"
      //   : null,
      ":active": {
        ...styles[":active"],
        backgroundColor: !isDisabled && (isSelected ? data.color : color),
        color: "white",
      },
    };
  },
};

/**
 * @description Este componente de <Select/> no es sencible al undefined, no le toma como null,
 * @param {*} param0
 * @returns
 */
export const DropDownFilter = ({
  name,
  rules,
  parserValue = null,
  onSelect = () => {},
  optionLabel = "label",
  optionValue = "value",
  options = [],
  onChangeFn,
  onMenuOpen = () => {},
  dataKey,
  loading,
  disabled = false,
  defaultValue = null,
  placeholder = "SELECCIONE",
  loadingText = "BUSCANDO...",
  helpText,
  filter = true,
  emptyFilterMessage = "NO SE HA ENCONTRADO INFORMACIÓN",
  ...props
}) => {
  const { control } = useFormContext();
  const objectPath = require("object-path");

  /**Mapeo de las opciones acorde a los requerimientos de ReactSelect */
  const opciones = options?.map((option) => ({
    label: objectPath.get(option, optionLabel),
    value: objectPath.get(option, optionValue),
  }));
  /**Mapeo de las opciones acorde a los requerimientos de ReactSelect */

  const { setRef } = useCustomRef(null);

  const internalPlaceHolder = useMemo(
    () => (loading ? loadingText : placeholder),
    [loading, placeholder, loadingText]
  );

  return (
    <React.Fragment>
      <Controller
        control={control}
        name={name}
        rules={rules}
        defaultValue={defaultValue}
        render={({ onChange, value }) => {
          const seleccion = opciones?.find((item) => {
            /**Cotejacion de value vs. opciones.value
             *Si el parametro cotejador parserValue no es nulo, su busca una opcion en donde SOLO coincida dicho parametro.
             *Caso contrario se busca la coincidencia completa del objeto via serializacion del mismo*/
            if (parserValue && value) {
              return (
                objectPath.get(value, parserValue) ===
                objectPath.get(item?.value, parserValue)
              );
            } else {
              return JSON.stringify(item?.value) === JSON.stringify(value);
            }
            /**Cotejacion de value vs. opciones.value*/
          });

          const esValido = seleccion?.label && seleccion?.value;

          /**Actualiza value con el objeto mas actual del catalogo */
          if (
            value &&
            seleccion?.value &&
            JSON.stringify(value) !== JSON.stringify(seleccion?.value)
          ) {
            onChange(seleccion?.value);
          }
          /**Actualiza value con el objeto mas actual del catalogo */

          return (
            <React.Fragment>
              <Select
                className='w-100 font-14px'
                id={name}
                //defaultValue={defaultValue}
                isClearable={true}
                isSearchable={true}
                isDisabled={loading || disabled}
                isLoading={loading}
                noOptionsMessage={() => emptyFilterMessage}
                loadingMessage={() => {
                  return "Buscando...";
                }}
                value={esValido ? seleccion : internalPlaceHolder}
                name={name}
                options={opciones}
                ref={setRef("select")}
                onMenuOpen={onMenuOpen}
                onChange={(evt) => {
                  if (evt) {
                    onChange(evt?.value);
                    //onChangeFn && onChangeFn(evt?.value);
                    onChangeFn && onChangeFn(evt.value ? evt.value : "");
                    onSelect(evt.value ? evt.value : "");
                  } else {
                    onChange(null);
                    onChangeFn && onChangeFn(null);
                  }
                }}
                placeholder={internalPlaceHolder}
                styles={customStylesDropDown}
              />
            </React.Fragment>
          );
        }}
      />
    </React.Fragment>
  );
};

export const SeleccionarFecha = ({
  name = "",
  rules,
  fechaInicio,
  fechaFin,
  placeholder,
  dateFormat = "EEEE, dd 'de' MMMM 'del' yyyy",
}) => {
  const { control } = useFormContext();
  registerLocale("es", es);

  return (
    <React.Fragment>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ onChange, value }) => {
          return (
            <React.Fragment>
              <DatePicker
                locale='es'
                selected={value}
                onChange={(date) => onChange(date)}
                minDate={new Date(fechaInicio)}
                maxDate={new Date(fechaFin)}
                placeholderText={placeholder}
                className='picker'
                isClearable
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode='select'
                onChangeRaw={(e) => {
                  e.preventDefault();
                }}
                dateFormat={dateFormat}
              />
            </React.Fragment>
          );
        }}
      />
    </React.Fragment>
  );
};

export const PrimeTextInput = ({
  rules,
  inputProps,
  extrasClasses,
  hideArrows = false,
  defaultValue = null,
  name,
  disabled = false,
  onChangeFn,
  ...rest
}) => {
  const { control } = useFormContext();
  const { focusRef, setRef } = useCustomRef();

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      defaultValue={defaultValue}
      onFocus={focusRef}
      render={({ onChange, value, ref }) => (
        <InputText
          className='input__mask__mex'
          value={value}
          onChange={(e) => {
            onChange(e.currentTarget.value);
            onChangeFn && onChangeFn(e.currentTarget.value);
          }}
          style={{
            border: "none",
            outline: "none",
            fontFamily: "SourceSansPro-Regular",
          }}
          disabled={disabled}
          {...rest}
          ref={setRef}
        />
      )}
    />
  );
};
